// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsSummaryStyles } from "@rpsc/App/Components/ProductDetails/ProductDetailsSummary";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { css } from "styled-components";

productDetailsSummaryStyles.container = {
    css: css`
        display: flex;
        justify-content: space-between;
        /* in case we have list variants */
        ul {
            display: flex;
        }
    `,
};

productDetailsSummaryStyles.leftSection = {
    css: css`
        display: flex;
        gap: 22px;
    `,
};

productDetailsSummaryStyles.rightSection = {
    css: css`
        min-width: 317px;
    `,
};

productDetailsSummaryStyles.productImage = {
    width: "91px",
    height: "91px",
    css: css`
        border-radius: 4px;
        overflow: hidden;
    `,
};

productDetailsSummaryStyles.productTitle = {
    size: 14,
    lineHeight: "16px",
    weight: fontConfig.weight.bold,
};

productDetailsSummaryStyles.titleWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        max-width: 440px;
        gap: 8px;
    `,
};

productDetailsSummaryStyles.actionStyles = {
    productGridContainer: {
        price: {
            css: css`
                display: flex;
                margin-bottom: 8px;
            `,
        },
    },
    productAvailabilityStyles: {
        container: {
            css: css`
                [data-test-selector="availabilityByWarehouseLink"] {
                    display: none;
                }
                width: fit-content;
                flex-grow: unset;
                margin: 0;
            `,
        },
    },
    productPrice: {
        wrapper: {
            css: css`
                margin: 0;
            `,
        },
    },
};
